<template>
  <div class="complementary-tree">
    <b-button
      class="d-flex justify-content-between"
      :class="{ 'attach-pressed': btnPressed }"
    >
      <div
        class="d-flex flex-fill align-items-center"
        @click="elementSelected"
      >
        <i
          class="far fa-layer-plus mr-2"
          aria-hidden="true"
        />
        <span>{{ label }}</span>
        <vtBubble
          :number="complementary.attachmentsCount"
          :type="false"
          :tooltip="` ${$tc('global.file', 2)}`"
        />
      </div>
    </b-button>
  </div>
</template>

<script>
import VtBubble from '@/components/common/VtBubble'
import complementaryAttachmentService from '@/api/resources/attachment/complementaryAttachmentService'
import { ComplementaryOperationGuardMixin } from '@/api/operations/mixins/guards/complementary-operation-guard.mixin'
import { ATTACHMENT_ENTITY_TYPE } from '@/api/resources/attachment/attachmentResource'

export default {
    name: 'ComplementaryTree',
    components: {
        VtBubble
    },
    mixins: [
        ComplementaryOperationGuardMixin
    ],
    props: {
        label: { type: String, required: true },
        laboratoryId: { type: Number, required: true },
        caseId: { type: Number, required: true },
        complementary: { type: Object, required: true }
    },
    data() {
        return {
            btnPressed: false,
            attachmentEntityType: ATTACHMENT_ENTITY_TYPE.COMPLEMENTARY,
            attachments: []
        }
    },
    computed: {
        entityId() {
            return this.complementary.id
        },
        entityDisplay() {
            return this.label
        },
        complementaryId() {
            return this.complementary.id
        },
        userHasAttachOperation() {
            return this.$_canAttachDocumentToComplementary()
        },
        canBeAttached() {
            return this.$_canBeDocumentAttachedToComplementary(this.complementary)
        }
    },
    methods: {
        async elementSelected() {
            this.btnPressed = true
            this.attachments = await complementaryAttachmentService.getAttachmentsForAttachmentType(this.laboratoryId, this.caseId, this.entityId)
            this.$emit('child-selected', this)
        },
        deselect() {
            this.btnPressed = false
        }
    }
}
</script>
